import { FC } from 'react'
import BaseItem, {
  ListItemMetaProps as BaseMetaProps,
  ListItemProps as BaseItemProps,
  Meta as BaseMeta,
} from 'antd/lib/list/Item'

export interface ListItemMetaProps extends BaseMetaProps {}

const Meta = (props: ListItemMetaProps): JSX.Element => (
  <>
    <BaseMeta {...props} />
  </>
)

export interface ListItemProps extends BaseItemProps {}

export interface ListItemTypeProps extends FC<ListItemProps> {
  Meta: typeof Meta
}

const Item: ListItemTypeProps = (props) => (
  <>
    <BaseItem {...props} />
  </>
)
Item.Meta = Meta

export { Item }
